import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ListAssigned, ProjectDetailsDto, ListWeek, ListProgress, ListStages, ListRisksMatrix, ListMilestones, ViewRisk, ListDependence } from '../../../interfaces/project/list/projectDetailsDto';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { TableOneSearch } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

export class listPay {

  id: number;
  date_reschedule: string;
  description: string;

}

export class infolistPay {

  id: number;
  title: string;
  scheduled_date: string;
  rescheduled_date: string;
  real_date: string;
  status: string;
  anexo: string;
  name: string;
  pay_amount: string;
  amount_percent: string;


}

@Component({
  selector: 'app-create-rescheduled-project',
  templateUrl: './create-rescheduled-project.component.html',
  styleUrls: ['./create-rescheduled-project.component.scss']
})
export class CreateRescheduledProjectComponent implements  OnInit {


  title = "Datos"
  idProject: number;
  id: number;
  nameProject:string;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  listAnexo: any[] = [];
  datos: infolistPay;
  listMoney: any[] = [];
  private apiService: ApiServiceProject;
  createPayForm: FormGroup;
  infoPayForm: FormGroup;
  idSubscription: Subscription;

  

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService

  ) {
    
    this.route.params.subscribe((params) => {
      this.id = params['id_pay'];
      this.idProject = params['id_project'];
      this.title = params['name'];
    });
  }

  ngOnInit(): void {
    
    this.apiService = new ApiServiceProject(this.http);
    this.createPayForm = this.fb.group({
      id: [0],
      date_reschedule: [''],
      description: [''],
    });

    this.infoPayForm = this.fb.group({
      id: [0],
      date_reschedule: [''],
      description: [''],
    });

    let rs = JSON.parse(localStorage.getItem("info-mtn"));

    rs.listProjectPlay.map((dato) => {
      if (dato.id == this.id) {
        this.datos = dato;

      }
    })

  }

 

  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }



  formSubmit(): void {
    this.spinner.show();
     

    if (this.createPayForm.value.date_reschedule === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.description === '') {
      this.spinner.hide();
      Swal.fire({title: 'Debe ingresar una descripción' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

  

   
    this.createPay = new listPay();
    this.createPay.id = Number(this.id);
    this.createPay.date_reschedule = moment(this.createPayForm.value.date_reschedule).format("DD-MM-YYYY"); 
    this.createPay.description = this.createPayForm.value.description;

    this.apiService.postService('project-play-reschedule', this.createPay)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Se ha reprogramado correctamente' ,text: '',icon: 'success',heightAuto: false})
            .then(() => [this.router.navigate(['/pdg/project/pay/list', this.idProject, this.title])
            ]);
            this.router.navigate(['/pdg/project/pay/list', this.idProject, this.title]);
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}